import React, { useEffect, useState, Fragment } from "react";
import { PageHeader } from "../../../Common";
import services from "../services";
import { BagQRPrintAddingSchema } from "../CardSchema";
import { validateProperty, validate } from "../../Common";
import Joi from "@hapi/joi";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import authService from "../../Common/services";
import tokenService from "../../../Common/tokenDecoder";
import { trackPromise } from "react-promise-tracker";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { MultiSelect } from "../../../Common/multiSelect";

const screenCode = "BAGQRPRINT";

export function BagQRPrintAdding(props) {
  const [groups, setGroups] = useState([]);
  const [operationEntity, setOperationEntity] = useState([]);
  const [collectionPoint, setCollectionPoint] = useState([]);
  const [selectedDivisions, setSelectedDivisions] = useState([]);
  const [multipleEstates, setMultipleEstates] = useState([]);
  const [errors, setErrors] = useState({});
  const [estateShortCodes, setEstateShortCodes] = useState({});
  const [divisionShortCodes, setDivisionShortCodes] = useState({});
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  const [bagQRAdd, setBagQRAdd] = useState({
    groupID: "0",
    operationEntityID: "0",
    divisionIDs: [],
    noOfCodes: "0",
  });

  const schema = Joi.object(BagQRPrintAddingSchema).options({
    allowUnknown: true,
  });

  useEffect(() => {
    trackPromise(getPermissions());
  }, []);

  useEffect(() => {
    if (bagQRAdd.groupID !== "0") {
      trackPromise(getOperationEntityForDropdown());
      trackPromise(getEstateShortCodes());
    }
  }, [bagQRAdd.groupID]);

  useEffect(() => {
    if (bagQRAdd.operationEntityID !== "0") {
      trackPromise(getCollectionPointForDropDown());
      trackPromise(getDivisionShortCodes());
    }
  }, [bagQRAdd.operationEntityID]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWBAGQRPRINT"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );

    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromTokenV2();

    if (token.operationEntities.length > 0) {
      var estateArray = [];

      for (let item of Object.entries(token.operationEntities)) {
        estateArray[item[1]["OperationEntityID"]] =
          item[1]["OperationEntityName"];
      }

      setMultipleEstates(estateArray);
    }

    setBagQRAdd({
      ...bagQRAdd,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });

    trackPromise(getGroupsForDropdown());
  }

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getOperationEntityForDropdown() {
    const operationEntityList =
      await services.getOperationEntityOptionsByGroupForDropDown(
        bagQRAdd.groupID
      );

    setOperationEntity(operationEntityList);
  }

  async function getCollectionPointForDropDown() {
    const collectionPointList =
      await services.getCollectionPointOptionsFilter(
        bagQRAdd.operationEntityID
      );

    setCollectionPoint(collectionPointList);
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, BagQRPrintAddingSchema);

    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  function handleGroupChange(target) {
    validateInputs(target);
    setSelectedDivisions([]);
    setCollectionPoint([]);

    setBagQRAdd({
      ...bagQRAdd,
      groupID: target.value,
      operationEntityID: "0",
      divisionIDs: [],
      noOfCodes: "0",
    });
  }

  function handleOperationEntityChange(target) {
    validateInputs(target);
    setSelectedDivisions([]);

    setBagQRAdd({
      ...bagQRAdd,
      operationEntityID: target.value,
      divisionIDs: [],
      noOfCodes: "0",
    });
  }

  function handleDivisionChange(selectedOptions) {
    const divisions = selectedOptions || [];
    setSelectedDivisions(divisions);

    setBagQRAdd({
      ...bagQRAdd,
      divisionIDs: divisions.map((x) => x.value),
    });
  }

  function handleNoOfCodesChange(target) {
    validateInputs(target);

    setBagQRAdd({
      ...bagQRAdd,
      noOfCodes: target.value,
    });
  }

  function generateDropDownMenu(data) {
    let items = [];

    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {getOptionName(value)}
          </MenuItem>
        );
      }
    }

    return items;
  }

  function generateMultiSelectItems(data) {
    if (data == null) return [];

    return Object.entries(data)
      .filter(([key, value]) => key !== "0" && value)
      .map(([value, option]) => ({
        value,
        label: getOptionName(option),
      }));
  }

  function getAllowedEstates() {
    return Object.fromEntries(
      Object.entries(operationEntity).filter(([key, value]) => {
        const estateName = getOptionName(value);

        if (key === "0" || !estateName) return false;

        if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
          return true;
        }

        return Object.values(multipleEstates).includes(estateName);
      })
    );
  }

  function getOptionName(option) {
    return typeof option === "object" ? option.name : option;
  }

  function getInitials(name) {
    if (!name) return "";

    return name
      .trim()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase())
      .join("");
  }

  function getAvailableDivisionIDs() {
    return Object.keys(collectionPoint).filter(
      (key) => key !== "0" && collectionPoint[key]
    );
  }
  function getSequenceFromTagNo(tagNo) {
    const tagSequence = String(tagNo || "").match(/(\d+)$/);
    return tagSequence ? Number(tagSequence[1]) : 0;
  }

  async function getLastSequenceNo(groupID, operationEntityID, divisionID) {
    const lastSequenceNo = await services.getLastBagQRSequenceNo(groupID, operationEntityID, divisionID);
    return Number(lastSequenceNo) || 0;
  }



  async function createGeneratedTags(divisionID) {
    const token = tokenService.getUserDetailsFromTokenV2();

    const groupName = getOptionName(groups[bagQRAdd.groupID]);
    const estateName = getOptionName(
      operationEntity[bagQRAdd.operationEntityID]
    );
    const divisionName = getOptionName(collectionPoint[divisionID]);

    const estateShortName = estateShortCodes[bagQRAdd.operationEntityID] || "";
    const divisionShortName = divisionShortCodes[divisionID] || "";

    const noOfCodes = parseInt(bagQRAdd.noOfCodes, 10);
    const generatedTags = [];

    const lastSequenceNo = await getLastSequenceNo(
      bagQRAdd.groupID,
      bagQRAdd.operationEntityID,
      divisionID
    );

    const startSequence = lastSequenceNo + 1;
    const endSequence = lastSequenceNo + noOfCodes;

    for (let sequence = startSequence; sequence <= endSequence; sequence++) {
      generatedTags.push({
        tagNo: `${estateShortName}/${divisionShortName}/${String(
          sequence
        ).padStart(4, "0")}`,
        groupID: bagQRAdd.groupID,
        operationEntityID: bagQRAdd.operationEntityID,
        collectionPointID: divisionID,
        sequenceNo: sequence,
        createdBy: token.id || 0,
        isActive: true,
        isPrint: false,
      });
    }

    return generatedTags;
  }

  async function handleGenerate(e) {
    e.preventDefault();

    const errorMessages = validate(schema, bagQRAdd);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});

    if (errorMessages) return;

    const divisionIDs =
      bagQRAdd.divisionIDs.length > 0
        ? bagQRAdd.divisionIDs
        : getAvailableDivisionIDs();

    let generatedTags = [];

    for (const divisionID of divisionIDs) {
      const tags = await createGeneratedTags(divisionID);
      generatedTags = generatedTags.concat(tags);
    }

    if (generatedTags.length > 0) {
      const response = await services.saveQRtags(generatedTags);

      if (response.statusCode === "Success") {
        props.history.push("/BagQRPrint");
      }
    }
  }

  async function getEstateShortCodes() {
    const list = await services.getOperationEntityShortCodesByGroup(bagQRAdd.groupID);
    const map = {};
    (list || []).forEach((x) => {
      map[x.operationEntityID] = x.bplEstateID;
    });
    setEstateShortCodes(map);
  }

  async function getDivisionShortCodes() {
    const list = await services.getCollectionPointShortCodesByOperationEntity(bagQRAdd.operationEntityID);
    const map = {};
    (list || []).forEach((x) => {
      map[x.collectionPointID] = x.bplDivisionID;
    });
    setDivisionShortCodes(map);
  }

  function clearState() {
    setSelectedDivisions([]);

    setBagQRAdd({
      ...bagQRAdd,
      divisionIDs: [],
      noOfCodes: "0",
    });
  }

  function handleSelectAllDivisions(selectAll) {
    const allItems = generateMultiSelectItems(collectionPoint);
    const divisions = selectAll ? allItems : [];

    setSelectedDivisions(divisions);
    setBagQRAdd({
      ...bagQRAdd,
      divisionIDs: divisions.map((x) => x.value),
    });
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />

      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <PageHeader
                title="Add Bag QR"
                isButtonEnable={true}
                buttonText="Back to Listing"
                path="/BagQRPrint"
              />

              <form
                onSubmit={(e) => trackPromise(handleGenerate(e))}
                disabled={false}
              >
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>

                    <Select
                      fullWidth
                      id="groupID"
                      name="groupID"
                      value={bagQRAdd.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>

                    {errors["groupID"] && (
                      <FormHelperText error>
                        {errors["groupID"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="operationEntityID">
                      Operation Entity *
                    </InputLabel>

                    <Select
                      fullWidth
                      id="operationEntityID"
                      name="operationEntityID"
                      value={bagQRAdd.operationEntityID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) =>
                        handleOperationEntityChange(e.target)
                      }
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(getAllowedEstates())}
                    </Select>

                    {errors["operationEntityID"] && (
                      <FormHelperText error>
                        {errors["operationEntityID"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="divisionIDs">
                      Collection Point
                    </InputLabel>

                    <MultiSelect
                      items={generateMultiSelectItems(collectionPoint)}
                      selectedValues={selectedDivisions}
                      label=""
                      placeholder="--Select Collection Point--"
                      noOptionsText="No Collection Points"
                      onToggleOption={handleDivisionChange}
                      onClearOptions={() => handleDivisionChange([])}
                      onSelectAll={handleSelectAllDivisions}
                      getOptionLabel={(option) => option.label}
                      isDisabled={bagQRAdd.operationEntityID === "0"}
                    />

                    {errors["divisionIDs"] && (
                      <FormHelperText error>
                        {errors["divisionIDs"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <TextField
                      fullWidth
                      label="QR Count *"
                      name="noOfCodes"
                      id="noOfCodes"
                      value={bagQRAdd.noOfCodes}
                      type="number"
                      onChange={(e) => handleNoOfCodesChange(e.target)}
                    />

                    {errors["noOfCodes"] && (
                      <FormHelperText error>
                        {errors["noOfCodes"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>

                <div className="card-footer">
                  <input
                    type="submit"
                    className="btn btn-primary"
                    value="GENERATE"
                  />

                  <input
                    type="button"
                    className="btn btn-warning pull-right"
                    value="CLEAR"
                    onClick={clearState}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
